import React from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

/**
 * Custom Link component that scrolls to the top of the page when navigating
 */
const Link: React.FC<LinkProps> = ({ children, to, ...props }) => {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    
    // Navigate to the specified route
    navigate(to);
    
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  };

  return (
    <RouterLink
      to={to}
      onClick={handleClick}
      {...props}
    >
      {children}
    </RouterLink>
  );
};

export default Link; 